// import React from "react";
// import { Worker, Viewer } from "@react-pdf-viewer/core";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";
// // import pdf1 from "../../assets/pdf/Syllabus-12.pdf";
// import "./../Previous/Previous.css";

// const PdfDemo1 = (props) => {
//   // const newPlugin = defaultLayoutPlugin();
//   const embeddedPdfUrl = `${props.file}#toolbar=0`;

//   return (
//     <>
//       <div className="view_pdf" style={{ position: "relative" }}>
//         {/* Embed tag for displaying the PDF */}
//         <embed
//           src={embeddedPdfUrl}
//           type="application/pdf"
//           width="100%"
//           height="800px"
//         />
//         <div
//           style={{
//             width: "40px",
//             height: "60px",
//             position: "absolute",
//             opacity: "0",
//             right: "33px",
//             top: "22px",
//             background: "black",
//             zIndex: "10",
//           }}
//         >
//           &nbsp;
//         </div>
//       </div>

//       <div className="view_pdf1" style={{ position: "relative" }}>
//         {/* Embed tag for displaying the PDF */}
//         <iframe
//           src={embeddedPdfUrl}
//           type="application/pdf"
//           width="100%"
//           height="800px"
//         />
//         <div className="Responsive-design">&nbsp;</div>
//         {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
//           <Viewer
//             classname="inner_pdf_content"
//             fileUrl={props.file}
//             plugins={[newPlugin]}
//           />
//           ;
//         </Worker> */}
//       </div>
//     </>
//   );
// };

// export default PdfDemo1;
import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import animation from "../../Lotties/download.json";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./../Previous/Previous.css";

const PdfDemo1 = ({ file, ApiData }) => {
  const [loading, setLoading] = useState(true);
  const newPlugin = defaultLayoutPlugin();
  const embeddedPdfUrl = `${file}#toolbar=0`;

  // Animation options for loading state
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    // Simulate loading time for PDF
    if (file) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [file]);

  if (!file) {
    return <div>No PDF file available</div>;
  }

  if (ApiData.apponly === "0") {
    return (
      <>
        <div className="view_pdf" style={{ position: "relative" }}>
          {/* Embed tag for displaying the PDF */}
          <embed
            src={embeddedPdfUrl}
            type="application/pdf"
            width="100%"
            height="800px"
          />
          <div
            style={{
              width: "40px",
              height: "60px",
              position: "absolute",
              opacity: "0",
              right: "33px",
              top: "22px",
              background: "black",
              zIndex: "10",
            }}
          >
            &nbsp;
          </div>
        </div>

        <div className="view_pdf1" style={{ position: "relative" }}>
          {/* Embed tag for displaying the PDF */}
          <iframe
            src={embeddedPdfUrl}
            type="application/pdf"
            width="100%"
            height="800px"
          />
          <div className="Responsive-design">&nbsp;</div>
        </div>
      </>
    );
  }

  // Function to determine height for blur overlay (40% from bottom)
  const calculateBlurHeight = () => {
    return "40%";
  };

  return (
    <div className="pdf-viewer-container">
      {loading ? (
        <div className="pdf-loading">
          <Lottie options={defaultOptions} height={100} width={100} />
          <p>Loading PDF...</p>
        </div>
      ) : (
        <div className="pdf-content">
          <div className="pdf-document">
            <iframe 
              src={`${file}#toolbar=0`}
              width="100%" 
              height="700px"
              title="PDF Viewer"
              className="pdf-iframe"
            />
            
            {/* Blur overlay for bottom 40% */}
            <div className="blur-overlay">
              <div className="blur-content">
                <h3>Want to see the complete PDF?</h3>
                <p>Download our app for free access to all pages</p>
                <a 
                  href="https://play.google.com/store/apps/details?id=com.rollingnotes&pli=1" 
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="download-app-btn"
                >
                  Download App
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .pdf-viewer-container {
          width: 100%;
          margin: 0 auto;
          position: relative;
        }
        
        .pdf-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
        }
        
        .pdf-document {
          position: relative;
          width: 100%;
          border: 1px solid #eee;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .pdf-iframe {
          display: block;
          border: none;
          pointer-events: none;
        }
        
        .blur-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: ${calculateBlurHeight()};
          background: linear-gradient(transparent, rgba(255, 255, 255, 0.7) 15%, rgba(255, 255, 255, 0.9));
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          backdrop-filter: blur(5px);
        }
        
        .blur-content {
          background: white;
          padding: 20px;
          border-radius: 8px;
          text-align: center;
          max-width: 80%;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }
        
        .blur-content h3 {
          margin-bottom: 10px;
          color: #333;
          font-size: 1.2rem;
        }
        
        .blur-content p {
          margin-bottom: 15px;
          color: #666;
        }
        
        .download-app-btn {
          display: inline-block;
          background: #4285F4;
          color: white;
          padding: 10px 20px;
          border-radius: 30px;
          text-decoration: none;
          font-weight: bold;
          transition: all 0.3s ease;
        }
        
        .download-app-btn:hover {
          background: #3367D6;
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default PdfDemo1;